import tools from 'utils/tools';

const AuthLayout = tools.lazyWithRetry(() => import('layouts/AuthLayout'));
const Login = tools.lazyWithRetry(() => import('components/pages/Auth/Login'));

const authRoutes = [
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [{ path: '', element: <Login /> }],
  },
];

export default authRoutes;
